(() => {
  const template = document.getElementById('tb-approved-wordmark-template');
  if (!template) return;
  const excluded = 'script,style,template,noscript,textarea,input,select,option,svg,math,iframe,[contenteditable],.visually-hidden,[data-tb-branded],a[href^="mailto:"],a[href^="tel:"]';
  const brand = /(?<![\p{L}\p{N}_@./-])(?:timbrata|تمبراتا)(?![\p{L}\p{N}_@/-]|\.[\p{L}\p{N}])/giu;
  const decorate = (node) => {
    const parent = node.parentElement;
    if (!parent || parent.closest(excluded)) return;
    const text = node.textContent;
    const matches = [...text.matchAll(brand)];
    if (!matches.length) return;
    const fragment = document.createDocumentFragment();
    let cursor = 0;
    for (const match of matches) {
      fragment.append(document.createTextNode(text.slice(cursor, match.index)));
      const mark = template.content.firstElementChild.cloneNode(true);
      mark.querySelector('.visually-hidden').textContent = match[0];
      fragment.append(mark);
      cursor = match.index + match[0].length;
    }
    fragment.append(document.createTextNode(text.slice(cursor)));
    node.replaceWith(fragment);
  };
  const scan = (root) => {
    if (root.nodeType === Node.TEXT_NODE) return decorate(root);
    if (root.nodeType !== Node.ELEMENT_NODE || root.matches(excluded)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(decorate);
  };
  scan(document.body);
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'characterData') scan(record.target);
      else record.addedNodes.forEach(scan);
    }
  });
  observer.observe(document.body, {childList:true, subtree:true, characterData:true});
})();
